<ng-container *transloco="let t">
  <div class="pb-200-228 mt-16">
    <div class="content-box">
      <div class="pb-300-100">
        <div class="content-box">
          <div class="row">
            <section class="col-12 col-md-6">
              <p class="medium pb-2 text-uppercase">
                {{ t('events.details.contacts.organiser') }}
              </p>
              <div class="pb-2">
                <p class="regular" *ngIf="isEventItem(event)">
                  {{
                    t('events.details.contacts.disclaimer', {organizer: (event?.organiser?.fullName ?? "")})
                  }}
                </p>
              </div>

              <div class="d-flex flex-row align-items-center">
                <span class="pe-1">
            <img src="assets/icons/icons-alt/location-alt.svg" alt="Location"/>
          </span>
                <p class="regular">
                  {{ event?.organiser?.address + (event?.organiser?.place ? (', ' + event!.organiser!.place) : '') +
                (event?.organiser?.country?.countryId ? (', ' + t('app.common.country.' +
                  event?.organiser!.country!.countryId)) : '') }}
                </p>
              </div>

              <div class="d-flex flex-row align-items-center">
          <span class="pe-1">
            <img src="assets/icons/icons-alt/phone-alt.svg" alt="Phone"/>
          </span>
                <p class="regular">
                  <a href="tel:{{event?.organiser?.phone ?? ''}}" class="text-black">{{
                      event?.organiser?.phone
                      ?? ""
                    }}</a>
                </p>
              </div>
              <div class="d-flex flex-row align-items-center">
          <span class="pe-1">
            <img src="assets/icons/icons-alt/email-alt.svg" alt="Phone"/>
          </span>
                <a href="mailto: {{event?.organiser?.email ?? ''}}">
                  <p class="regular">{{ event?.organiser?.email ?? "" }}</p>
                </a>
              </div>
            </section>
            <section class="col-12 col-md-6">
              <div class="p-3 br-4 teal-50-bg">
                <p class="medium pb-2 text-uppercase cursor-pointer" (click)="openContactOrganiserModal()">
                  {{ t('events.details.contacts') }}
                </p>
                <div>
                  <p class="medium d-inline-flex">{{ t('events.details.contacts.results.email')}}&nbsp;</p>
                  <a href="mailto:{{event?.organiser?.email ?? ''}}">
                    <p class="regular d-inline-flex">{{ event?.organiser?.email ?? "" }}</p>
                  </a>
                </div>
<!--                <div>
                  <p class="medium d-inline-flex">{{ t('events.details.contacts.applications.phone') }}</p>
                  <a href="tel:{{event?.organiser?.phone ?? ''}}">
                    <p class="regular d-inline-flex">{{
                        event?.organiser?.phone
                        ?? ""
                      }}</p>
                  </a>
                </div>
                <div>
                  <p class="medium d-inline-flex">{{ t('events.details.contacts.results.phone') }}</p>
                  <a href="tel:{{event?.organiser?.phone ?? ''}}">
                    <p class="regular d-inline-flex">{{
                        event?.organiser?.phone
                        ?? ""
                      }}</p></a>
                </div>-->
                <div>
                  <div>
                    <p class="medium d-inline-flex">{{ t('app.landing.other') }}:</p>
                  </div>
                  @for (phoneNumber of event?.phoneNumbers;track phoneNumber) {
                    <div class="d-flex">
                      <p class="regular d-inline-flex">
                        <app-language-output [hrLabel]="phoneNumber.name"
                                             [enLabel]="phoneNumber.nameEng"
                                             [srLabel]="phoneNumber.nameSr"
                                             [bsLabel]="phoneNumber.nameBs"
                                             [itLabel]="phoneNumber.nameIta" [siLabel]="phoneNumber.nameSlo"
                                             [defaultLanguage]="event?.defaultLanguage"
                                             [defaultLabel]="t('event.awardFund.details.empty')" [languages]="languages"/>
                      </p>
                      <a href="tel:{{phoneNumber.phone ?? ''}}">
                        <p class="regular ms-2">
                          {{
                            phoneNumber.phone
                            ?? ""
                          }}</p></a>
                    </div>
                  }
                </div>
                <div class="d-flex align-items-center">
                  {{ event?.organiser?.fullName ?? "" }}
                </div>
              </div>
            </section>
          </div>
        </div>
      </div>
    </div>
  </div>
</ng-container>
